import MasterCrud from "@/components/app/MasterCrud";
export default function Units() {
  return (
    <MasterCrud endpoint="/units" title="Satuan"
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama", type: "text", required: true },
      ]}
    />
  );
}
